import { render, staticRenderFns } from "./myprofile.vue?vue&type=template&id=0e816eab&"
import script from "./myprofile.vue?vue&type=script&lang=js&"
export * from "./myprofile.vue?vue&type=script&lang=js&"
import style0 from "./myprofile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports